export default __webpack_public_path__ + "static/media/C-8.fdd8bcb5.png";